/* global BigInt */

// Porting di convertRFID da thor-central-system-server-ocpp-1.6 (StartTransaction/Authorize):
// la colonnina invia l'UID esadecimale, Thor inverte l'ordine dei byte e lo salva come decimale a 10 cifre.
const STANDARD_VENDORS = ['schneider', 'setec', 'mennekes', 'smartbit', 'abb', 'alfen', 'autel'];
const SCAME_VENDORS = ['scame', 'scame_gs'];

const reverseBytes = (hex) => {
  let ret = '';
  while (ret.length < hex.length) {
    let from = hex.length - (ret.length + 2);
    ret += from < 0 ? hex.substr(0, 1) : hex.substr(from, 2);
  }
  return ret;
};

const swapNibbles = (hex) => {
  let ret = '';
  for (let idx = 0; idx < hex.length; idx += 2) {
    ret += idx === hex.length - 1 ? hex[idx] : `${hex[idx + 1]}${hex[idx]}`;
  }
  return ret;
};

const hexToDecimal = (hex) => {
  try {
    return BigInt(`0x${hex}`).toString().padStart(10, '0');
  } catch (err) {
    return null;
  }
};

export const convertRFID = (input, vendor) => {
  let i = input.toLowerCase().replace(/\s/g, '');
  if (vendor === 'phoenix') {
    i = swapNibbles(i);
  } else if (SCAME_VENDORS.includes(vendor)) {
    if (i.length === 14 && i.endsWith('000000')) {
      i = i.substr(0, 8);
    }
  } else if (!STANDARD_VENDORS.includes(vendor)) {
    return i;
  }
  return hexToDecimal(reverseBytes(i)) || i;
};

// Inversa di convertRFID: dal valore salvato su transactions_running ricava l'idTag originale inviato dalla colonnina.
// Gli zeri finali dell'UID originale non sono recuperabili, quindi si porta a 4 o 7 byte (le lunghezze tipiche):
// StopTransaction riconverte comunque il valore, che porta allo stesso id_tag.
export const revertRFID = (idTag, vendor) => {
  if (![...STANDARD_VENDORS, ...SCAME_VENDORS, 'phoenix'].includes(vendor) || !/^\d+$/.test(idTag)) {
    return idTag;
  }
  let hex = BigInt(idTag).toString(16);
  let length = hex.length <= 8 ? 8 : hex.length <= 14 ? 14 : hex.length + (hex.length % 2);
  hex = reverseBytes(hex.padStart(length, '0'));
  if (vendor === 'phoenix') {
    hex = swapNibbles(hex);
  }
  return hex.toUpperCase();
};

// Le transazioni locali (RFID letto dalla colonnina) hanno l'id_tag convertito; quelle remote (Stripe/Nayax)
// o pagate da RFID via app lo hanno salvato così com'è. Stessa regola usata da StopTransaction per il confronto.
export const getStopIdTag = (transaction, vendor) => {
  let idTag = transaction.idTag || '';
  if (transaction.type !== 'local' || (transaction.payment && transaction.payment.method === 'rfid')) {
    return idTag;
  }
  let reverted = revertRFID(idTag, vendor);
  if (convertRFID(reverted, vendor) !== idTag.toLowerCase()) {
    throw new Error(`Cannot revert idTag ${idTag} for vendor ${vendor}`);
  }
  return reverted;
};
